import { useMutation, useQueryClient } from "@tanstack/react-query";

import { deleteFieldPracticeParticipations } from "services";

import { invalidateCarbonProgramQueriesByChunk, invalidateQueriesByChunk } from "utils";

import { DELETE_FIELD_PRACTICE_PARTICIPATIONS, GET_FARM_DATA_SUBMISSION_STATUS, GET_FIELD_DETAILS, GET_FIELD_PRACTICES } from "consts";

export const useDeleteFieldPracticeParticipations = (fieldId: string, farmId?: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [DELETE_FIELD_PRACTICE_PARTICIPATIONS],
    mutationFn: deleteFieldPracticeParticipations,
    onSuccess: () => {
      invalidateCarbonProgramQueriesByChunk(fieldId);
      invalidateQueriesByChunk(GET_FIELD_PRACTICES, fieldId);
      queryClient.invalidateQueries({ queryKey: [GET_FARM_DATA_SUBMISSION_STATUS, farmId] });
      // Field details need to be re-fetched to reflect possible exceeding of hectare limit
      queryClient.invalidateQueries({ queryKey: [GET_FIELD_DETAILS] });
    },
  });
};
